import PasswordInput from "./PasswordInput.vue";

export default PasswordInput;
